import {Tag} from 'quickstart/components/controls/Tag'
import {formFields} from 'quickstart/lib/search/config'
import {summaryList} from 'quickstart/lib/search/summary'
import {chain, map, pipe} from 'rambdax'
import {logger} from 'tizra'

const log = logger('quickstart/components/tizra/SearchTags')

export const SearchTags = ({
  search,
  search: {config, params, update},
  ...rest
}) => {
  const fs = formFields(config, 'filterTags')
  const tags = pipe(
    chain(f => summaryList(f, params[f.name])),
    map(({key, label, name, removed, summary}) => (
      <Tag
        key={key}
        size="sm"
        variant="action"
        onClick={() => update({[name]: removed})}
      >
        {label && `${label}: `}
        {summary}
      </Tag>
    )),
  )(fs)

  return tags.length === 0 ? null : (
    <Tag.Group>Currently filtering by:&ensp;{tags}</Tag.Group>
  )
}

/*
SearchTags.propTypes = {
  search: T.object.isRequired,
}
*/
